<template>
  <div>
    <div class="breadcrumbs">
      <div class="container">
        <a href="/">首页</a> <span class="sep">/</span> <span>个人中心</span>
      </div>
    </div>
    <div class="mi-user-portal page-main">
      <div class="container ">
        <div class="row">
          <div class="span4">
            <left-nav></left-nav>
          </div>
          <div class="span16">
            <div class="mi-uc-box uc-main-box">
              <div class="uc-content-box portal-content-box">
                <div class="box-bd">
                  <h2 class="main-title">个人中心</h2>
                  <div class="portal-sub">
                    <ul class="info-list clearfix">
                      <li>
                        <h3>
                          待支付的订单：<span class="num">{{
                            form.count.wait
                          }}</span>
                        </h3>
                        <a @click="goWaitOrder()"
                          >查看待支付订单<i class="iconfont"></i></a
                        ><img
                          src="//s01.mifile.cn/i/user/portal-icon-1.png"
                          alt=""
                        />
                      </li>
                      <li>
                        <h3>
                          待收货的订单：<span class="num">{{
                            form.count.confirm
                          }}</span>
                        </h3>
                        <a @click="goConfirmOrder()"
                          >查看待收货订单<i class="iconfont"></i></a
                        ><img
                          src="//s01.mifile.cn/i/user/portal-icon-2.png"
                          alt=""
                        />
                      </li>
                      <li>
                        <h3>
                          喜欢的商品：<span class="num">{{
                            form.count.like
                          }}</span>
                        </h3>
                        <a @click="goLike()"
                          >查看喜欢的商品<i class="iconfont"></i></a
                        ><img
                          src="//s01.mifile.cn/i/user/portal-icon-4.png"
                          alt=""
                        />
                      </li>
                      <li>
                        <h3>
                          购物车里的商品：<span class="num">{{
                            form.count.cart
                          }}</span>
                        </h3>
                        <a @click="goCart()"
                          >查看购物车<i class="iconfont"></i></a
                        ><img
                          src="//s01.mifile.cn/i/user/portal-icon-4.png"
                          alt=""
                        />
                      </li>
                      <li>
                        <h3>
                          报价篮商品：<span class="num">{{
                            form.count.basket
                          }}</span>
                        </h3>
                        <a @click="goBasket()"
                          >查看报价篮<i class="iconfont"></i></a
                        ><img
                          src="//s01.mifile.cn/i/user/portal-icon-4.png"
                          alt=""
                        />
                      </li>
                      <li>
                        <h3>
                          账户余额：<span class="num">{{ form.balance }}</span>
                        </h3>
                        <a @click="goFinance()"
                          >查看财务往来<i class="iconfont"></i></a
                        ><img
                          src="//s01.mifile.cn/i/user/portal-icon-4.png"
                          alt=""
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LeftNav from "../Layout/LeftNav.vue";
import { api } from "@/assets/js/util.js";
export default {
  name: "Profile",
  components: {
    "left-nav": LeftNav,
  },
  data() {
    return {
      form: {
        count: {},
      },
      is_read_only: true,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    goWaitOrder() {
      this.$router.push("/order?status=WAIT_PAY");
    },
    goConfirmOrder() {
      this.$router.push("/order?status=WAIT_CONFIRM");
    },
    goLike() {
      this.$router.push("/like");
    },
    goCart() {
      this.$router.push("/cart");
    },
    goBasket() {
      this.$router.push("/inquiry");
    },
    goFinance() {
      this.$router.push("");
    },
    onEdit() {
      this.is_read_only = false;
    },
    isReadOnly() {
      if (this.is_read_only) {
        return "is_read_only";
      }
    },
    getData() {
      let that = this;
      api.post("profile/info", {}).then(function(res) {
        if (res.code) {
          that.form = res.data;
        }
      });
    },
  },
};
</script>
<style>
.is_read_only {
  pointer-events: none;
}
.is_read_only input {
  border: 0 !important;
}
</style>
